import { FeatureDc, ProjectContentItemDc } from "@evergis/api";

import { isPolyGeometry, isPolygonGeometry, UnknownGeometry } from "./geometry";

export type ExtendedProjectContentItemDc = ProjectContentItemDc & {
  path?: string[];
};

export const isPolylineFeature = (feature: FeatureDc) => isPolyGeometry(feature?.geometry as UnknownGeometry);

export const isPolygonFeature = (feature: FeatureDc) => isPolygonGeometry(feature?.geometry as UnknownGeometry);
